module.exports = __webpack_public_path__ + "img/ballast_bag.bc277610.png";